<template>
  <div>
    <el-button type="default" class="mb-1 small" circle @click.prevent="onDecrease">
      <i class="el-icon-minus"></i>
    </el-button>
    <span class="font-weight-bold">{{ value.quantity }}</span>
    <el-button type="default" class="mb-1 small" circle @click.prevent="onIncrease">
      <i class="el-icon-plus"></i>
    </el-button>


  </div>
</template>

<script>
export default {
  props: {
    option: {
      type: Object,
      required: true
    },
    value: {
      type: Object,
      required: true
    },
    parentOption:{
      type: Object,
      default: null
    }
  },
  methods: {
    onIncrease() {
      this.$emit('increase', { option: this.option, value: this.value })
    },
    onDecrease() {
      this.$emit('decrease', { option: this.option, value: this.value, parentOption: this.parentOption })
    }
  }
}
</script>